
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-12-09/L1001030-color_8efb98b3b1__20.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-12-09/L1001030-color_8efb98b3b1__400.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-12-09/L1001030-color_8efb98b3b1__800.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-12-09/L1001030-color_8efb98b3b1__1600.jpg";


export default {
  id: "L1001030-color",
  aspect: 1.5123684210526316,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        